"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePicker = exports.RangeDatePicker = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var moment_1 = tslib_1.__importDefault(require("moment"));
var rc_picker_1 = tslib_1.__importStar(require("rc-picker"));
var moment_2 = tslib_1.__importDefault(require("rc-picker/lib/generate/moment"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var Button_1 = tslib_1.__importDefault(require("../Button"));
var icons_1 = require("../icons");
var ConfigProvider_1 = require("../ConfigProvider");
var PopupContainerProvider_1 = require("../PopupContainerProvider");
var utils_1 = require("../utils");
var input_1 = require("../Input/input");
var hooks_1 = require("../utils/hooks");
var defs_1 = require("../Form/defs");
function PickerButton(props) {
    return react_1.default.createElement(Button_1.default, tslib_1.__assign({ size: "small", type: "primary" }, props));
}
function RangeDatePicker(props) {
    var valueFromProps = props.value, _a = props.defaultValue, defaultValue = _a === void 0 ? { start: null, end: null } : _a, onChange = props.onChange, rootHtmlProps = props.rootHtmlProps;
    var _b = hooks_1.useValue({ valueFromProps: valueFromProps, defaultValue: defaultValue, onChange: onChange }), value = _b.value, setValue = _b.setValue;
    var sharedProps = useSharedProps(props);
    var _c = ConfigProvider_1.useLangData('datePicker'), rangeDateText = _c.rangeDateText, rangeTimeText = _c.rangeTimeText;
    var placeholder = sharedProps.picker === 'time' ? rangeTimeText : rangeDateText;
    var handleChange = function (values, _formatString) {
        setValue({ start: (values === null || values === void 0 ? void 0 : values[0]) ? values[0].valueOf() : null, end: (values === null || values === void 0 ? void 0 : values[1]) ? values[1].valueOf() : null });
    };
    return (react_1.default.createElement(rc_picker_1.RangePicker, tslib_1.__assign({}, rootHtmlProps, sharedProps, { value: [(value === null || value === void 0 ? void 0 : value.start) ? moment_1.default(value.start) : null, (value === null || value === void 0 ? void 0 : value.end) ? moment_1.default(value.end) : null], placeholder: placeholder, separator: react_1.default.createElement(icons_1.SwapRightIcon, null), onChange: handleChange })));
}
exports.RangeDatePicker = RangeDatePicker;
function DatePicker(props) {
    var valueFromProps = props.value, _a = props.defaultValue, defaultValue = _a === void 0 ? null : _a, onChange = props.onChange, rootHtmlProps = props.rootHtmlProps;
    var _b = hooks_1.useValue({ valueFromProps: valueFromProps, defaultValue: defaultValue, onChange: onChange }), value = _b.value, setValue = _b.setValue;
    var sharedProps = useSharedProps(props);
    var _c = ConfigProvider_1.useLangData('datePicker'), dateText = _c.dateText, timeText = _c.timeText;
    var placeholder = sharedProps.picker === 'time' ? timeText : dateText;
    var handleChange = function (val, _dateString) {
        setValue(val && val.valueOf());
    };
    return (react_1.default.createElement(rc_picker_1.default, tslib_1.__assign({}, rootHtmlProps, sharedProps, { value: value ? moment_1.default(value) : null, placeholder: placeholder, onChange: handleChange })));
}
exports.DatePicker = DatePicker;
function useSharedProps(_a) {
    var _b = _a.type, type = _b === void 0 ? 'date' : _b, disableWhen = _a.disableWhen, _c = _a.disabled, disabled = _c === void 0 ? false : _c, size = _a.size, validateStatus = _a.validateStatus, cls = _a.className, style = _a.style, _d = _a.clearable, clearable = _d === void 0 ? false : _d, onOpenChange = _a.onOpenChange;
    var prefix = ConfigProvider_1.usePrefix('picker');
    var focused = hooks_1.useFocused().focused;
    var colorStyle = input_1.useInputColor({
        focused: focused,
        validateStatus: validateStatus,
        disabled: disabled
    });
    var formSize = defs_1.useFormSize(size);
    var className = classnames_1.default(colorStyle, prefix, cls, utils_1.concat(prefix, formSize));
    var lang = ConfigProvider_1.useLangData('datePicker');
    var _e = parseDateType(type), picker = _e.picker, showTime = _e.showTime, format = _e.format;
    var getPopupContainer = PopupContainerProvider_1.useGetPopupContainer();
    return {
        picker: picker,
        format: format,
        showTime: showTime,
        prefixCls: prefix,
        className: className,
        style: style,
        disabled: disabled,
        size: size,
        components: { button: PickerButton },
        prevIcon: react_1.default.createElement("span", { className: utils_1.concat(prefix, 'prev-icon') }),
        nextIcon: react_1.default.createElement("span", { className: utils_1.concat(prefix, 'next-icon') }),
        superPrevIcon: react_1.default.createElement("span", { className: utils_1.concat(prefix, 'super-prev-icon') }),
        superNextIcon: react_1.default.createElement("span", { className: utils_1.concat(prefix, 'super-next-icon') }),
        clearIcon: react_1.default.createElement(icons_1.CloseCircleFilledIcon, null),
        suffixIcon: picker === 'time' ? react_1.default.createElement(icons_1.ClockCircleIcon, null) : react_1.default.createElement(icons_1.CalendarIcon, null),
        generateConfig: moment_2.default,
        locale: lang,
        allowClear: clearable,
        disabledDate: disableWhen ? function (date) { return disableWhen(date.valueOf()); } : undefined,
        dropdownClassName: utils_1.concat(prefix, 'dropdown'),
        onOpenChange: onOpenChange,
        getPopupContainer: getPopupContainer
    };
}
// type的格式为startFormat-endFormat，date、time和datetime是其中三种常用格式的缩写
var typeMap = {
    date: 'year-day',
    time: 'hour-second',
    datetime: 'year-second'
};
// 以month-day举例，得到的是format.substring(5, 10)，即为format.substring(startPosition[1], endPosition[2] + 1)
var dateSet = ['year', 'month', 'day', 'hour', 'minute', 'second'];
var startPosition = [0, 5, 8, 11, 14, 17];
var endPosition = [3, 6, 9, 12, 15, 18];
var format = 'YYYY-MM-DD HH:mm:ss';
function parseDateType(type) {
    var dateType = typeMap[type] || type;
    var _a = dateType.split('-'), startType = _a[0], endType = _a[1];
    var picker = 'date';
    var showTime;
    var startIndex = dateSet.findIndex(function (_type) { return _type === startType; });
    var endIndex = dateSet.findIndex(function (_type) { return _type === endType; });
    if (startIndex === -1 || endIndex === -1) {
        throw Error('you should use correct type to date picker');
    }
    if (startIndex > 2) {
        picker = 'time';
    }
    if (type === 'year-month') {
        picker = 'month';
    }
    if (endIndex > 2) {
        showTime = { format: format.substring(startPosition[Math.max(3, startIndex)], endPosition[endIndex] + 1) };
        if (!showTime.format.includes('s')) {
            showTime.showSecond = false;
        }
        if (!showTime.format.includes('m')) {
            showTime.showMinute = false;
        }
        if (!showTime.format.includes('H')) {
            showTime.showHour = false;
        }
    }
    return { picker: picker, showTime: showTime, format: format.substring(startPosition[startIndex], endPosition[endIndex] + 1) };
}
//# sourceMappingURL=index.js.map